import { IsVisibleOnFilterCountBaseValueConverter } from 'General/Resources/ValueConverters/IsVisibleOnFilterCountBase';
export class IsVisibleOnFilterCountValueConverter extends IsVisibleOnFilterCountBaseValueConverter {

}